import CustomText from "@components/CustomText";
import color from "@constants/color";
import { colors } from "@constants/theme";

import React from "react";
import {
  TouchableOpacity,
  StyleSheet,
  View,
  ActivityIndicator,
} from "react-native";

const BottomButton = ({
  onPress = () => {},
  title = "",
  loading = false,
  disable = false,
  totalMissingQty = 0,
  totalMissingAmount = 0,
}) => {
  return (
    <View style={styles.absoluteContainer}>
      <View style={styles.topContainer}>
        <CustomText
          variant="caption_2"
          style={{ color: colors.black06, lineHeight: 20 }}
        >
          {`Lost/Damage Qty: `}
          <CustomText variant="title_16" style={{ color: colors.black }}>
            {totalMissingQty}
          </CustomText>
        </CustomText>
        <CustomText
          variant="caption_2"
          style={{ color: colors.black06, lineHeight: 20 }}
        >
          {` Lost/Damage Amount: `}
          <CustomText variant="title_16" style={{ color: colors.black }}>
            {`₹${totalMissingAmount}`}
          </CustomText>
        </CustomText>
      </View>
      <TouchableOpacity
        testID="docl-crate-scan"
        disabled={loading || disable}
        activeOpacity={0.8}
        onPress={onPress}
        style={[
          styles.scanButton,
          disable && { backgroundColor: colors.black02 },
        ]}
      >
        {loading ? (
          <ActivityIndicator size="small" color={colors.white} />
        ) : (
          <CustomText variant="title_16" style={styles.scanButtonText}>
            {title}
          </CustomText>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default BottomButton;

const styles = StyleSheet.create({
  absoluteContainer: {
    backgroundColor: "white",
    position: "absolute",
    paddingBottom: 10,
    bottom: 0,
    width: "100%",
    padding: 16,
    paddingTop: 12,
    elevation: 10,
  },
  scanButton: {
    backgroundColor: colors.plain_green,
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
  scanButtonText: {
    color: colors.white,
  },
  topContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginBottom: 12,
    padding: 4,
    paddingBottom: 0,
    paddingHorizontal: 10,
    borderRadius: 8,
  },
});
